import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "w-full flex flex-col pl-3 justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-sm" }, "OUR COMPANY’S PERSONALITY", -1)
const _hoisted_4 = { class: "text-xl font-black text-white" }
const _hoisted_5 = { class: "flex flex-col justify-between pr-4" }
const _hoisted_6 = {
  id: "share_ebp",
  class: "p-auto"
}
const _hoisted_7 = {
  id: "ebp_modal",
  class: "-mb-4 p-auto"
}
const _hoisted_8 = { class: "w-full flex flex-col pl-1 justify-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-sm" }, "OUR COMPANY’S PERSONALITY", -1)
const _hoisted_10 = { class: "text-xl font-black text-white" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "workbean-share mr-3" }, null, -1)
const _hoisted_13 = {
  key: 3,
  class: "m-auto my-10 w-full text-center text-gray-100 font-bold"
}

import { computed, onMounted } from "vue"
  import { useCompanyStore } from "@/store/company"
  import { useResourcesStore } from "@/store/resources"
  import { useRoute } from "vue-router"
  import { caretDownOutline, shareSocialOutline, copy } from "ionicons/icons"
  import { IonIcon } from "@ionic/vue"
  import { find } from "lodash"
  import { toastController } from "@ionic/core"
  import { record } from "@/utils/analytics"

  import EmployeeReviews from "@/components/workbean-page/culture/EmployeeReviews.vue"
  import CultureStories from "@/components/workbean-page/culture/CultureStories.vue"
  import BottomModal from "@/components/template/BottomModal.vue"
  import EbpCard from "@/components/workbean-page/culture/EbpImage.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CulturePage',
  setup(__props) {

  const store = useCompanyStore()
  const resourcesStore = useResourcesStore()
  const route = useRoute()

  const companyDetails = computed(() => store.companyDetails)
  const ebpList = computed(() => resourcesStore.ebp)
  const companyEbp = computed(() => companyDetails.value.insight.ebp || { id: "" })
  const ebpObject = computed(() => {
    const objectFound = find(ebpList.value, { id: companyEbp.value.id })
    if (objectFound) {
      return {
        label: objectFound.name,
        color: objectFound.color,
        description: objectFound.description.full,
        shortDescription: objectFound.description.peak,
      }
    } else return undefined
  })
  const storiesData = computed(() => {
    if (companyDetails.value.story) {
      companyDetails.value.story.map((val: any) => {
        return {
          description: val.description,
          title: val.title,
          video: val.link,
        }
      })
    }
    return []
  })
  const shareEbpOptions = ["Share to LinkedIn", "Share to Facebook", "Copy URL"]

  /**
   * get window location
   */
  const getLocation = () => window.location.toString()

  /**
   * Share function
   * share
   */
  const copyUrl = async () => {
    navigator.clipboard.writeText(getLocation().includes("#ebp") ? getLocation() : `${getLocation()}#ebp`)
    const toast = await toastController.create({
      message: "EBP link copied to clipboard!",
      duration: 3000,
      position: "top",
      color: "info",
    })
    await toast.present()
  }
  onMounted(() => {
    record({
      event: "CompanyViewPage",
      attributes: {
        link: route.fullPath,
        company_id: companyDetails.value.company_id,
      },
    })
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(companyDetails).subscription !== 'Free' && _unref(companyEbp) && _unref(companyEbp).id && _unref(companyEbp).id.length > 0 && _unref(ebpObject))
      ? (_openBlock(), _createBlock(EbpCard, {
          key: 0,
          data: _unref(ebpObject),
          class: "pl-3 pt-5 py-5 mb-28"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(ebpObject).label), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", _hoisted_6, [
                  _createVNode(_unref(IonIcon), {
                    class: "text-3xl text-white",
                    icon: _unref(shareSocialOutline)
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("button", _hoisted_7, [
                  _createVNode(_unref(IonIcon), {
                    class: "text-3xl text-white",
                    icon: _unref(caretDownOutline)
                  }, null, 8, ["icon"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true),
    _createVNode(BottomModal, {
      type: "ebp_modal",
      style: _normalizeStyle(`--ion-background-color: ${_unref(ebpObject)?.color}`)
    }, {
      default: _withCtx(() => [
        _createVNode(EbpCard, { data: _unref(ebpObject) }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("h2", _hoisted_10, _toDisplayString(_unref(ebpObject)?.label), 1)
            ])
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("p", {
          class: "text-white border-t-1 border-white pt-5",
          innerHTML: _unref(ebpObject)?.description
        }, null, 8, _hoisted_11)
      ]),
      _: 1
    }, 8, ["style"]),
    _createVNode(BottomModal, { type: "share_ebp" }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shareEbpOptions, (shareOption, index) => {
          return _createElementVNode("div", {
            key: `${index}_id`,
            class: "my-3 text-center"
          }, [
            (index === 2)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  expand: "block",
                  color: "white",
                  class: "normal-case",
                  style: { color: 'inherit' },
                  onClick: copyUrl
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      class: "text-xl mr-3",
                      icon: _unref(copy)
                    }, null, 8, ["icon"]),
                    _createTextVNode(_toDisplayString(shareOption), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_ShareNetwork, {
                  key: 1,
                  network: index == 0 ? 'linkedin' : 'facebook',
                  url: `${getLocation()}${getLocation().includes('\#ebp') ? '' : '\#ebp'}`,
                  description: `${_unref(ebpObject)?.shortDescription}`,
                  title: `${_unref(companyDetails).name.trim()}'${_unref(companyDetails).name.trim().endsWith('s') ? '' : 's'} Employer Brand Personality - Workbean`,
                  hashtags: "workbean,employer_brand_personality,"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      class: "normal-case",
                      style: { color: 'inherit' }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode(_toDisplayString(shareOption), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["network", "url", "description", "title"]))
          ])
        }), 64))
      ]),
      _: 1
    }),
    (_unref(storiesData) && _unref(storiesData).length)
      ? (_openBlock(), _createBlock(CultureStories, {
          key: 1,
          "culture-data": _unref(storiesData),
          "company-data": { name: _unref(companyDetails).name, image: _unref(companyDetails).logo }
        }, null, 8, ["culture-data", "company-data"]))
      : _createCommentVNode("", true),
    (_unref(companyDetails).testimonial && _unref(companyDetails).testimonial.length)
      ? (_openBlock(), _createBlock(EmployeeReviews, {
          key: 2,
          reviews: _unref(companyDetails).testimonial,
          "company-name": _unref(companyDetails).name
        }, null, 8, ["reviews", "company-name"]))
      : _createCommentVNode("", true),
    (!_unref(companyEbp).id && _unref(companyEbp).id.length === 0 && _unref(storiesData) && _unref(storiesData).length === 0 && _unref(companyDetails).testimonial && _unref(companyDetails).testimonial.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, " No culture data yet "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})